<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>
<script>
import $axios from "@/plugins/axios";
import { Alert } from 'element-ui';
import { EventBus } from '../public/eventBus';
import auth from "@/utils/auth";
export default {
  name: 'App',
  data() {
    return {
      title: '',
      agentId: ''
    };
  },
  // async beforeCreate(){
  //   if(!localStorage.getItem('languageSet')){
  //     localStorage.setItem('languageSet', 'zh')
  //   }
  //   if (!localStorage.getItem("language")) {
  //     try {
  //       const response = await $axios.get('Language/list', {
  //         status: 0
  //       });
  //       if (response.data.code == 1) {
  //         localStorage.setItem("language", JSON.stringify(response.data.data));
  //         this.$reslove("获取成功");
  //         return;
  //       }
  //     } catch (error) {
  //     }
  //   }
  //   if (localStorage.getItem("language") && localStorage.getItem('languageSet')) {
  //     this.$reslove();
  //   }
  // },
  async created() {
    // this.updateTitle()
    // EventBus.$on('update-title', this.updateTitle);
  },
  mounted() {
    // if (this._isMobile()) {
    //     console.log('手机端');
    //     this.$router.replace('/mobile');
    // } else {
    //     console.log('pc端');
    //     this.$router.replace('/index'); 
    // }
    this.$reslove();
  },
  methods: {
    async checkLocalStorageChange() {
      if (!localStorage.getItem('languageSet')) {
        localStorage.setItem('languageSet', 'zh')
      }
      if (!localStorage.getItem("language")) {
        try {
          const response = await $axios.get('Language/list', {
            status: 0
          });
          if (response.data.code == 1) {
            localStorage.setItem("language", JSON.stringify(response.data.data));
            this.$reslove("获取成功");
            return;
          }
        } catch (error) {
        }
      }
      if (localStorage.getItem("language") && localStorage.getItem('languageSet')) {
        this.$reslove();
      }
    },
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    // async updateTitle() {
    //   try {
    //     let response = '';
    //     if (auth.getToken() != null && auth.getToken() != '') {
    //       this.$api.login.getAgentIdByOrgId({ orgId: auth.getMember().orgId }).then(async (x) => {
    //         if (x.data.data == null) {
    //           this.title = '至乐心理'
    //         } else {
    //           const agentRes = await this.$api.login.getAgentIdByOrgId({ orgId: auth.getMember().orgId });
    //           this.agentId = agentRes.data.data;
    //           const systemTitleRes = await this.$api.login.getSystemTitle({ agentId: this.agentId });
    //           response = systemTitleRes.data.data;
    //           this.title = response;
    //         }
    //         document.title = this.title;
    //       })
    //     }
    //     else {
    //       document.title = '至乐心理'
    //     }
    //   } catch (error) {
    //     console.error('Error fetching title:', error);
    //   }
    // }
  },
}
</script>
<style lang="scss">
.app {
  *::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 7px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 7px;
  }

  *::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    background-color: transparent;
    /*background: #535353;*/
  }

  *::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: transparent;
  }

  *::-webkit-scrollbar,
  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
}
</style>
